"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleize = handleize;
exports.hash = hash;
exports.capitalize = capitalize;
exports.unbem = unbem;

require("core-js/modules/es6.regexp.replace");
/**
 * Utils: Filters
 * -----------------------------------------------------------------------------
 * Output strings and values into a format you require.
 * - Imported into global Vue.filters in styleguide.js.
 */


function handleize(value) {
  return value.toLowerCase().replace(' ', '-');
}

function hash(value) {
  return "#".concat(value);
}

function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function unbem(value) {
  return value.replace('__', ' ').replace('--', ' ');
}